import React, { useState } from 'react';
import { Avatar, Button, Input, Spin } from 'antd';
// 使用 window.message 代替 antd 静态方法，避免 context 警告
import { SendOutlined, CommentOutlined } from '@ant-design/icons';
import RadarChartSection from '../card/RadarChartSection';
import LineChartSection from '../card/LineChartSection';
import useProposalResultStyles from '../../styles/components/proposal/ProposalResult';
import Comments from '../comment/Comments';

const { TextArea } = Input;

const ProposalResult = ({ stats, comments: initialComments, radarData, lineData, optimizeMode, contentId }) => {
  const { styles } = useProposalResultStyles();
  const [loading, setLoading] = useState(false);
  const [comments, setComments] = useState(initialComments || []);
  const [newComment, setNewComment] = useState('');
  const [submitting, setSubmitting] = useState(false);


  // 提交反馈
  const handleSubmitFeedback = async (comment) => {
    setSubmitting(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setComments(prev => [comment, ...prev]);
      setNewComment('');
      window.message?.success('反馈发布成功');
    } catch (error) {
      window.message?.error('反馈发布失败');
    } finally {
      setSubmitting(false);
    }
  };

  // 处理折线图数据格式
  const processedLineData = React.useMemo(() => {
    if (lineData && lineData.length > 0) {
      return {
        step: [
          {
            agent: '点赞趋势',
            score: lineData.map(item => ({
              version: item.version,
              confidence: item.confidence / 100
            }))
          }
        ]
      };
    }
    return undefined;
  }, [lineData]);

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className={`${styles.container} ${optimizeMode ? 'bg-[var(--color-assist-6)]' : ''}`}>
      {/* 顶部数据和图表区域 - 同一行布局 */}
      <div className={styles.topSection}>
        {/* 左侧数据列 */}
        <div className={styles.statsRow}>
        <div className={styles.statsColumn}>
          {/* 社区点赞 */}
          <div className={styles.statItem}>
            <div className={styles.statLabel}>社区点赞</div>
            <div className={styles.statNumber}>{stats?.community_likes || stats?.like_count}</div>
            <div className={styles.statTrend}>{stats?.community_trend}</div>
          </div>
          {/* 评委打分 */}
          <div className={styles.statItem}>
            <div className={styles.statLabel}>评委打分</div>
            <div className={styles.statNumber}>{stats?.judge_score}</div>
            <div className={styles.statTrend}>{stats?.judge_trend}</div>
          </div>
        </div>
        {/* 右侧图表区域：雷达图和折线图并排 */}
        <div className={styles.chartRow}>
          <div className={styles.chartContainer}>
            <div className={styles.chartTitle}>评委各维度打分</div>
            <RadarChartSection radarData={radarData} height={250} />
          </div>
          <div className={styles.chartContainer}>
            <div className={styles.chartTitle}>点赞趋势</div>
            <LineChartSection card={processedLineData} height={250} />
          </div>
        </div>
        </div>
      </div>
      {/* 社区反馈区域 */}
      <div className={styles.feedbackSection}>
        <div className={styles.feedbackHeader}>
          <h3 className={styles.feedbackTitle}>社区反馈</h3>
        </div>
        <Comments contentId={contentId} />
      </div>
    </div>
  );
};

export default ProposalResult;